import { InvalidArgumentException } from "../../Global/Base/Exceptions";
import { contextlessInstanceOf } from "../../Global/Base/Polyfill/instanceOf";
/**
 * V ServiceWorkeru neni dostupná
 */
export interface DOMError {
    readonly name: string;
    toString(): string;
}

export type ErrorType = Error | DOMError;

/**
 * Výjimka IndexedDB
 */
export class IDBException extends Error {
    private readonly _innerError: ErrorType | undefined;

    public get innerError(): ErrorType | undefined {
        return this._innerError;
    }

    constructor(message?: string, innerError?: ErrorType) {
        super(message);
        this.name = this.constructor.name;
        if (innerError) {
            this._innerError = innerError;
        }
    }

    public static override [Symbol.hasInstance](instance: any): boolean {
        return instance != null && contextlessInstanceOf(instance, IDBExceptions.getRegisteredExceptionType(this.name));
    }

    public override toString(): string {
        return this.message;
    }
}

/**
 * Výjimka, která označuje že selhala transakce nad IndexedDB
 */
export class IDBTransactionException extends IDBException {
    /***Flag, jestli místo chybové zprávy indexed DB zobrazit chybu pro session timeout (Využívá se pro opravu bugu s přístupem do indexedDb v chrome )*/
    public convertToSessionTimeout: boolean = false; //ošetří výjimku, kterou produkuje bug v chrome.

    constructor(message?: string, innerError?: ErrorType) {
        super(message, innerError);
    }
}

/**
 * Výjimka, která označuje že selhal request do IndexedDB
 */
export class IDBRequestException extends IDBException {
    constructor(message?: string, innerError?: ErrorType) {
        super(message, innerError);
    }
}

// pokud definujeme tridu IDBExceptions pred definici vyjimek OWExceptions, tak je staticka promenna registeredExceptions naplnena hodnotami undefined :-(
export class IDBExceptions {
    /**
    * Vrátí třídu nalezené výjimky, která byla zaregistrovaná pro deserializaci při příchodu ze služby
    * @param exceptionName název hledané výjimky
    */
    public static getRegisteredExceptionType(exceptionName: string): new(faultElement: any) => IDBException {
        if (!exceptionName)
            throw new InvalidArgumentException("exceptionName");

        return IDBExceptions._registeredExceptions[exceptionName];
    }

    private static readonly _registeredExceptions: { [key: string]: new(faultElement: any) => IDBException } = {
        "IDBException": IDBException,
        "IDBTransactionException": IDBTransactionException,
        "IDBRequestException": IDBRequestException,
    };
}
